import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "@activecollab/components";
import PropTypes from "prop-types";
import { usePrepareFileUrl } from "~/components/Hooks/usePrepareFileUrl";
import Angie from "~/utils/angie.jsx";

export const DownloadButton = React.forwardRef(({ fileSize, variant, url, ...props }, ref) => {
  const { t } = useTranslation();

  const downloadUrl = usePrepareFileUrl(url);

  return (
    <Link
      ref={ref}
      href={downloadUrl}
      className="btn btn--pro-2"
      variant={variant}
      download
      {...props}
    >
      {t("Download")} ({Angie.functions.format_file_size(fileSize)})
    </Link>
  );
});

DownloadButton.propTypes = {
  url: PropTypes.string.isRequired,
  fileSize: PropTypes.number,
  variant: PropTypes.string,
};

DownloadButton.defaultProps = {
  fileSize: 0,
  variant: "primary",
};

DownloadButton.displayName = "DownloadButton";
